export function Tile({ label, value, mood }: { label: string; value: string; mood?: string }) {
  return (
    <div className={`tile ${mood ? `mood-${mood}` : ""}`}>
      <p className="meta-label">{label}</p>
      <p className="tile-value">{value}</p>
    </div>
  );
}
